<template>
  <div class="page">
    <div id="cover-spin" v-if="loading"></div>
    <div class="flex-fill" style="background: #141313;">
      <div class="header py-4">
        <div class="container">
          <div class="d-flex">
            <div class="d-flex order-lg-2">
              <img
                src="../assets/images/logo2.png"
                loading="lazy"
                style="height:100px;"
              />
            </div>
            <div class="d-flex order-lg-2 ml-auto" style="align-items: center">
              <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
            </div>
            <!--
            <div class="d-flex order-lg-2 ml-auto">
              <div class="dropdown">
                <a
                  href="#"
                  class="nav-link pr-0 leading-none"
                  data-toggle="dropdown"
                >
                  <span
                    class="avatar"
                    id="avatar"
                    :style="{ 'background-image': `url(${pictureUrl})` }"
                  ></span>
                </a>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
      <div style="align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
            <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
                  <div style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;">
                      <span class="glow" ref="myBtn">
                        {{loadingtext}}
                      </span>
                  </div>
              </div> 
          </div>
      <div style="margin-bottom: 78px;" >
        <div v-for="(items,index) in rewards" v-bind:key="index" style="margin-left: 16px; margin-right: 16px; margin-top: 16px; margin-bottom: 32px; display: flex; flex: 1; flex-direction: row; justify-content: center;">
            <div v-for="(item,index2) in items" v-bind:key="index+'-'+index2" style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-radius: 7px;text-align: center;" >
                  <img :src="item.image" style="width:130px;height:120px;">
                </div>
                <div :class="(selected)?`canredeem`:`cantredeem`" :disabled="isDisabled" @click="redeem(item)">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      เลือก
                    </span>
                </div>
            </div>
        </div>
      </div>
        <!-- <div style="margin-left: 16px; margin-right: 16px; margin-top: 16px; margin-bottom: 32px; display: flex; flex: 1; flex-direction: row; justify-content: center;">
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://fiverr-res.cloudinary.com/images/t_main1,q_auto,f_auto,q_auto,f_auto/gigs/97896300/original/8e69991bafd163b3f601f388df24401c7ff9bd6d/create-custom-starbucks-logo.png"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >StarBucks</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://img.wongnai.com/p/1920x0/2019/12/03/a98c6133a6924512a96c66675d7299b5.jpg"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >Shopee</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
        </div>
        <div style="margin-left: 16px; margin-right: 16px; margin-top: 16px; margin-bottom: 32px; display: flex; flex: 1; flex-direction: row; justify-content: center;">
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://sitestatic.airasiabig.com/uploadswebcms/public/5eb/6c8/945/5eb6c89459f46505371128.jpg"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >Tesco Lotus</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://dglfp4udgtr5h.cloudfront.net/wp-content/uploads/2020/02/Logo_BU-09.png"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >Central</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
        </div>
        <div style="margin-left: 16px; margin-right: 16px; margin-top: 16px; margin-bottom: 32px; display: flex; flex: 1; flex-direction: row; justify-content: center;">
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://pbs.twimg.com/profile_images/1214743567991599104/gqXU3pdc_400x400.jpg"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >The Mall</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://ratewhatever.net/productimages/7857570-e893325df0a38484f40d1731225c55b3_big%20c.jpg"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >Big C</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
        </div>
        <div style="margin-left: 16px; margin-right: 16px; margin-top: 16px; margin-bottom: 32px; display: flex; flex: 1; flex-direction: row; justify-content: center;">
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://bkworld.in.th/showcases/project-themask/images/logo-major.png"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >Major Cineple</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://cf.shopee.co.th/file/ebd4c2e4fb850950dc9bc6853ee7dd4b"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >SF Cinema</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
        </div>

        <div style="margin-left: 16px; margin-right: 16px; margin-top: 16px; margin-bottom: 32px; display: flex; flex: 1; flex-direction: row; justify-content: center;">
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://www.atmindgroup.com/atmindplus/wp-content/uploads/2018/11/bbq-plaza.jpg"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 12px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >BAR-B-Q Gift Voucher</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://lh3.googleusercontent.com/proxy/p7lQWtZmon79HHfI-tMRNoJQoMP278P059ylRO7F1mNj8noRv-VsuYvgEq-Jc_je5D_11a6dBlFa7_EqtLyJcowblpLJDHC2FidC7g"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 15px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >MK Gift Voucher</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
        </div>
        <div style="margin-left: 16px; margin-right: 16px; margin-top: 16px; margin-bottom: 32px; display: flex; flex: 1; flex-direction: row; justify-content: center;">
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://images-na.ssl-images-amazon.com/images/I/712ijeHnkAL._AC_SX522_.jpg"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 14px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >KFC Gift Voucher</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
            <div style="margin-right: 8px; flex: 1;">
                <div style="background: #fff; border-top-left-radius: 7px; border-top-right-radius: 7px;" >
                  <img src="https://timesamui.com/upload/places/07/25/the-pizza-company-1112.jpg?1580311385"
                  style="object-fit: cover; border-top-left-radius: 7px; border-top-right-radius: 7px;">
                </div>
                <div style="padding-left: 16px;padding-top: 16px; background: #FFF;font-size: 12px;color: #ee4e2e;justify-content: space-between;font-weight: 900;"><span >The Pizza Company</span></div>
                <div style="min-height: 120px; background: #FFF; padding: 16px; padding-top: 10px; text-indent: 8px; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                    <span style="color: #000; font-size: 14px;font-family:SukhumvitSet-Blod;">Comming Soon</span>
                </div>

                <div class="cantredeem">
                    <span style="font-size: 14px; font-weight: bold; color: #fff;">
                      <img src="../assets/images/coin.png" width="20">
                      แลก 
                    </span>
                </div>
            </div>
        </div> -->
    </div>
    <BottomMenu></BottomMenu>
  </div>
</template>

<script>
import "../assets/css/dashboard.css";
import firebase from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import _ from 'lodash';
import liffService from "@/services/liff";
// @ is an alias to /src
export default {
  name: "Register",
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  components: {
    BottomMenu: require("./BottomMenu").default,
  },
  data() {
    return {
      tabs: [
      { title: 'เครดิต', value: 'tab1' },
      { title: 'ของรางวัล', value: 'tab2' },
      ],
      currentTab: 'tab1',
      displayName: "",
      //email: "",
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: false,
      error: "",
      mycoin:0,
      rewards:[],
      userKey:'',
      selected:false,
      loadingtext:'น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่',
    };
  },
  methods: {
    handleClick(newTab) {
      this.currentTab = newTab;
    },
    redeem: function(item){
        if(!this.isDisabled && this.selected){
            this.$confirm(
                {
                title: 'Are you sure?',
                message: `‼️ ยืนยันการเลือกกระทงนี้?`,
                button: {
                    no: 'No',
                    yes: 'Yes'
                },
                /**
                 * Callback Function
                 * @param {Boolean} confirm 
                 */
                callback: confirm => {
                    if (confirm && this.userKey) {
                        this.isDisabled = true;
                        this.loading = false;
                        this.mycoin += item.coin;
                        firebase.firestore().collection('scratch').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).set({
                            userId:this.userId,
                            createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                            spin:item.coin,
                            value:item.coin
                        });
                        this.$confirm(
                            {
                                message: `ปังปุรีเย่!! คุณได้รับ ${item.coin} เหรียญ😘😘`,
                                button: {
                                yes: 'OK'
                                },
                                callback: async (confirm) => {
                                    if (confirm) {
                                        this.sendMessageLine3(item.coin+' เหรียญ');
                                    }
                                }
                            }
                        );	
                    }else{
                    this.loading = false;
                    }
                }
                }
            )
        }
    },
    async sendMessageLine(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🌕 "+text,
          }
      ]);
      window.liff.closeWindow();
    },
    async sendMessageLine2(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🌕 "+text,
          },
      ]);
    },
    async sendMessageLine3(text){
      await window.liff.sendMessages([{
        "type": "flex",
        "altText": 'ปังปุรีเย่!! คุณได้รับ '+text,
        "contents": {
              "type": "bubble",
              "size": "micro",
              "body": {
                "type": "box",
                "layout": "vertical",
                "contents": [
                  {
                    "type": "text",
                    "text": "ยินดีด้วยค่ะ !",
                    "color": "#ffffff",
                    "size": "lg",
                    "weight": "bold",
                    "align": "center"
                  },
                  {
                    "type": "image",
                    "url": "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media",
                    "position": "relative",
                    "size": "sm"
                  },
                  {
                    "type": "text",
                    "text": "+"+text,
                    "size": "sm",
                    "color": "#ffffff",
                    "align": "center",
                    "weight": "bold"
                  }
                ],
                "spacing": "xxl",
                "margin": "none",
                "action": {
                  "type": "uri",
                  "label": "action",
                  "uri": "https://liff.line.me/2006378234-72e9GVNa/reward",
                  "altUri": {
                    "desktop": "https://liff.line.me/2006378234-72e9GVNa/reward"
                  }
                },
                "background": {
                  "type": "linearGradient",
                  "angle": "0deg",
                   "startColor": "#ffb347",
                   "endColor": "#000000"
                }
              },
              "styles": {
                "footer": {
                  "separator": true
                }
              }
            }
          }]);
      window.liff.closeWindow();
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      this.displayName = profile.displayName ? profile.displayName : "none";
      this.statusMessage = profile.statusMessage
        ? profile.statusMessage
        : "none";
      if (this.userId) {
        const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
        if (user) {
            const u = user[Object.keys(user)[0]];
            this.mycoin = u.coins;
            const rewards2 = (await firebase.database().ref(`/kathong`).once("value")).val();
            const rewards = [];
            for(const x in rewards2){
                rewards2[x].key = x;
                rewards.push(rewards2[x]);
            }
            const rewards3 = rewards;
            const rewardsdata = [];
            let i = 0;
            let page = 0;
            for(const x in rewards3){
                if(!rewardsdata[page]) {
                    rewardsdata[page] = [];
                }
                rewardsdata[page].push(rewards3[x]);
                if(i%2 == 1){
                    page++;
                }
                i++;
            }
            this.rewards = rewardsdata;
            this.userKey = Object.keys(user)[0];
            this.sendMessageLine2("สนใจเลือกกระทงค่ะ พลอยใสจัดการให้หน่อย 😘😘");
            if(moment().tz("Asia/Bangkok").format("YYYY-MM-DD") === '2023-11-27') {
                await firebase.firestore().collection('scratch').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then(async (snapshot) => {
                    if(snapshot.exists) {
                        this.sendMessageLine("ลูกค้าเลือกกระทงไปแล้วนะคะ 😘😘");
                    }else{
                        await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 18:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:00').get().then(async (snapshot) => {
                            let credit = 0;
                            snapshot.forEach((doc)=>{
                                credit += Number(doc.data().qty);
                            });
                            if(credit >= 500){
                                this.loadingtext = 'น้องออโต้พร้อมแล้วเลือกกระทงได้เลยค่ะ😘😘';
                                this.showLoading = true;
                                this.isDisabled = false;
                                this.selected = true;
                            }else{
                                const less = 500-Number(credit);
                                this.loadingtext = `เติมเงินอีก ${less}(500) ได้เล่นเลยค่ะ!😘😘`;
                            }
                        });
                    }
                });
            }else{
                this.loadingtext = `กิจกรรมนี้เฉพาะวันที่ 27 พฤศจิกายน เท่านั้น!😘😘`;
            }
        }else{
          router.replace("/register");
        }
      }
    },
  }
};
</script>
<style scoped>
.center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
        padding-top: 50%;
        height: 100%;
      }
.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
    
    to {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
}
#cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#cover-spin::after {
  content: "";
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: black;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  -webkit-animation: spin 0.8s linear infinite;
  animation: spin 0.8s linear infinite;
}
.canredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #1672ce; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
.cantredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #a5a4a4; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
</style>
